import styles from "./NoisyText.css";
import { withTranslation } from "../translation";
import PropTypes from "prop-types";

const NoisyText = ({ formatTranslation }) => (
  <div
    className={styles.noisyTextContainer}
    aria-label={formatTranslation("quick_join_overlay_title_web_A11y")}
  >
    {formatTranslation("quick_join_overlay_title_web")
      .split("/")
      .map((text, i) => (
        <span key={i} className={styles.noisyText} aria-hidden="true">
          {text.trim()}
        </span>
      ))}
  </div>
);

NoisyText.propTypes = {
  formatTranslation: PropTypes.func
};

export default withTranslation(NoisyText);
